import Config from "./config";
import postWindowMessage from "./post_window_message";
import ProgendaUtils from "./progenda_utils.js";
import createSessionToken from "./create_session_token";

const paramsMapping =
    {
        remote_id: "integrateId",
        patient_id: "patientId",
        appointment_id: "appointmentId",
        center_id: "centerId",
        calendar_id: "calendarId",
        patient_remote_id: "patientIntegrateId"
    }

async function getToken(targetPath, type, useProgendaDomain, callbackToken) {
    const response = await createSessionToken(targetPath, type, undefined, useProgendaDomain);
    callbackToken(response.url);
}

function parseContent(href, type, scope, useProgendaDomain, context, callback) {
    if(href.startsWith("?")) { // Hash item
        let newData = {};
        const paramsArray = href.substr(1).split("&");
        paramsArray.forEach(param => {
            const [key, value] = param.split("=");
            newData[paramsMapping[key]] = value;
        });
        callback(newData)
    } else if(href.startsWith("/")) { // Internal link, need to include SSO token
        const domain = useProgendaDomain ? Config.get().host : window.location.origin; // target path might be Progenda
        href = domain + href;
        let urlObject = new URL(href);
        let pathname = urlObject.href;
        let searchParams = new URLSearchParams(urlObject.search);
        let hash = urlObject.hash;
        if(scope) searchParams.set("scope", scope);
        if(context) searchParams.set("context", context) ;
        let targetPath = `${pathname}${pathname.includes("?") ? "&" : "?"}${searchParams.toString()}${hash}`;
        getToken(targetPath, type, useProgendaDomain, (url) =>  {
            callback({url: url})
        });
    }
    else { // external Link
        callback({url: href})
    }
}


const openExternalLink = (event, type, href, scope = 'FULL', useProgendaDomain = false, context = ProgendaUtils.getCookie('context')) => {
    let useHelenaEmbeddable = Config.get().useHelenaEmbeddable;
    if(event){
        // avoid to open link via <a> + eventualy window open action
        event.preventDefault();
    }
    if(useHelenaEmbeddable){ //
        parseContent(href, type, scope, useProgendaDomain, context, data => {
            if (context === "FAT_CLIENT" || type === "open-patient") {
                postWindowMessage(type, "1", data);
            } else {
                window.open(data.url, "_blank","noopener noreferrer")
            }
        })
    }
    else {
        window.open(href, "_blank","noopener noreferrer")
    }
}

export default openExternalLink;